import { render, staticRenderFns } from "./storeManagement_discountSetting.vue?vue&type=template&id=e040705c&"
import script from "./storeManagement_discountSetting.vue?vue&type=script&lang=js&"
export * from "./storeManagement_discountSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports